import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SplitterComponent } from './splitter.component';
import { SplitterPanelComponent } from './splitter-panel.component';

@NgModule({
    declarations: [
        SplitterComponent,
        SplitterPanelComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        SplitterComponent,
        SplitterPanelComponent
    ]
})
export class NcSplitterModule { }